import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import { FETCH_MERCHANDISE_TOP_BRANDS } from 'actions/apiActionConstants'
import getMerchandiseTopBrands from 'api/merchandise/getMerchandiseTopBrands'

function fetchMerchandiseTopBrands(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const existing = state.merchandise.merchandiseTopBrands
    if (existing) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANDISE_TOP_BRANDS,
      request: () => getMerchandiseTopBrands(),
    })
  }
}

export default fetchMerchandiseTopBrands
